<template>
  <div class="home" v-if="!isLoading">
    <c-banner/>
    <c-about/>
    <c-news/>
    <c-word-grexy/>
    <c-update-section/>
    <c-game/>
    <c-benefits/>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import cBanner from '@/components/Banner'
import cAbout from '@/components/AboutNewSection'
import cNews from '@/components/MainPageNewsSection'
import cProblemStatement from '@/components/ProblemStatement'
import cSolutionsOffered from '@/components/SolutionsOffered'
import cYellowSection from '@/components/YellowSection'
import cNotifiedModal from '@/components/NotifiedModal'
import cHowWorks from '@/components/HowWorks'
import cGame from '@/components/Game'
import cFunctionContent from '@/components/FunctionContent'
import cBenefits from '@/components/Benefits'
import cShopSection from '@/components/ShopSection'
import cWordGrexy from '@/components/WordGrexy'
import cSliderPhoto from '@/components/SliderPhoto'
import cUpdateSection from '@/components/UpdateSection'

export default {
  name: 'Home',
  components: {
    cBanner,
    cAbout,
    cNews,
    cProblemStatement,
    cSolutionsOffered,
    cYellowSection,
    cNotifiedModal,
    cHowWorks,
    cGame,
    cFunctionContent,
    cBenefits,
    cShopSection,
    cWordGrexy,
    cSliderPhoto,
    cUpdateSection
  },
  mounted () {
    const hasVisitedBefore = localStorage.getItem('hasVisitedBefore')

    if (!hasVisitedBefore) {
      this.actionPreloader(true)

      localStorage.setItem('hasVisitedBefore', 'true')

      setTimeout(() => {
        this.actionPreloader(false)
      }, 2000)
    }
  },
  computed: {
    ...mapState({
      isLoading: state => state.preloader.isLoading
    })
  },
  methods: {
    ...mapActions(['actionPreloader'])
  }
}
</script>
